var _breakpoints, _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import { grommet } from "grommet";
import { deepMerge } from "grommet/utils";
import { css } from "styled-components";
import { NameSpace } from "../../const/namespace";
export var customTheme = deepMerge(grommet, {
  global: {
    breakpoints:
      ((_breakpoints = {}),
      (_breakpoints[NameSpace.minimobile] = {
        value: 375,
      }),
      (_breakpoints[NameSpace.mobile] = {
        value: 576,
      }),
      (_breakpoints[NameSpace.tablet] = {
        value: 991,
      }),
      (_breakpoints[NameSpace.desktop1200] = {
        value: 1200,
      }),
      (_breakpoints[NameSpace.desktop1400] = {
        value: 1400,
      }),
      (_breakpoints[NameSpace.desktop1900] = {
        value: 3000,
      }),
      _breakpoints),
    spacing: "12px",
    font: {
      family: "Gotham Pro, sans-serif",
      size: "24px",
      height: "32px",
      fontStyle: "normal",
    },
    colors: {
      brand: "#315FB6",
      "site-colors-1": "#F8F8F8",
      "site-colors-2": "#E8EAEC",
      "site-colors-3": "#EDEFF2",
      "site-colors-4": "#D0DAE8",
      "dark-site-color": "#1A1A1A",
      grey: "#D1D4D8",
      "dark-blue": "#333F51",
      black: "#000000",
      white: "#ffffff",
      text: {
        light: "#333333",
        dark: "#ffffff",
      },
      focus: "transparent",
    },
    heading: {
      weight: 700,
      level: {
        1: {
          xlarge: {
            size: "56px",
            height: "64px",
          },
        },
        2: {
          xlarge: {
            size: "50px",
            height: "58px",
          },
        },
        3: {
          medium: {
            size: "38px",
            height: "46px",
          },
        },
        4: {
          small: {
            size: "24px",
            height: "34px",
          },
        },
        5: {
          xsmall: {
            size: "18px",
            height: "26px",
          },
        },
        6: {
          xxsmall: {
            size: "16px",
            height: "24px",
          },
        },
      },
    },
    paragraph: {
      font: {
        family: "Gotham Pro",
        fontStyle: "normal",
        small: {
          size: "12px",
          height: "20px",
        },
        medium: {
          size: "14px",
          height: "22px",
        },
        large: {
          size: "16px",
          height: "24px",
        },
        xlarge: {
          size: "18px",
          height: "26px",
        },
        xxlarge: {
          size: "24px",
          height: "32px",
        },
      },
    },
  },
  tab: {
    active: {
      background: "black",
      color: "white",
    },
    default: {
      background: {
        color: "grey",
      },
    },
    background: "grey",
    border: undefined,
    hover: {
      background: "black",
      color: "white",
    },
    margin: undefined,
    pad: {
      top: "20px",
      bottom: "14px",
      horizontal: "21px",
    },
    extend: function extend() {
      return css(
        _templateObject ||
          (_templateObject = _taggedTemplateLiteralLoose([
            "\n      border-radius: 20px 20px 0px 0px;\n    ",
          ]))
      );
    },
  },
  tabs: {
    gap: "26px",
  },
});
